var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.studiesLoader.total === 0
        ? [_c("h3", [_vm._v("No active studies")])]
        : _vm.studiesLoader.total === _vm.studiesLoader.loaded
        ? [
            _vm.$parent.routeSection === 0
              ? [_c("DispensingUnit", { attrs: { formValue: _vm.formValue } })]
              : _vm.$parent.routeSection === 1
              ? [_c("Ancillary", { attrs: { formValue: _vm.formValue } })]
              : _vm.$parent.routeSection === 2
              ? [_c("PackingCampaign", { attrs: { formValue: _vm.formValue } })]
              : _vm.$parent.routeSection === 3
              ? [_c("SiteDepotStock", { attrs: { formValue: _vm.formValue } })]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }